import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';
// assets
import { colors } from 'components/styles/variables';

function CurrentOpenings() {
  const { t } = useTranslation();

  return (
    <div className="outer-container">
      <a name="jobs" />
      <div className="container">
        <div className="row">
          <div className="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
            <div className="message-container">
              <h2>{t('aboutUs.position.title')}</h2>
              {ReactHtmlParser(t('aboutUs.position.text'))}
              <div className="row positions">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>
                      <a
                        href="https://boards.greenhouse.io/cargurus/jobs/2612554?gh_jid=2612554&utm_campaign=autolistCom&utm_source=autolistCom&utm_medium=organic"
                        rel="nofollow"
                      >
                        Engineering Manager
                        <span>{t('aboutUs.position.location')}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://boards.greenhouse.io/cargurus/jobs/2398433?gh_jid=2398433&utm_campaign=autolistCom&utm_source=autolistCom&utm_medium=organic"
                        rel="nofollow"
                      >
                        Sr Android Engineer
                        <span>{t('aboutUs.position.location')}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://boards.greenhouse.io/cargurus/jobs/2398396?gh_jid=2398396&utm_campaign=autolistCom&utm_source=autolistCom&utm_medium=organic"
                        rel="nofollow"
                      >
                        Principal Engineer
                        <span>{t('aboutUs.position.location')}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>
                      <a
                        href="https://boards.greenhouse.io/cargurus/jobs/2612555?gh_jid=2612555&utm_campaign=autolistCom&utm_source=autolistCom&utm_medium=organic"
                        rel="nofollow"
                      >
                        Engineering Manager
                        <span>Austin, TX</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://boards.greenhouse.io/cargurus/jobs/2538087?gh_jid=2538087&utm_campaign=autolistCom&utm_source=autolistCom&utm_medium=organic"
                        rel="nofollow"
                      >
                        Sr Android Engineer
                        <span>Austin, TX</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://boards.greenhouse.io/cargurus/jobs/2538097?gh_jid=2538097&utm_campaign=autolistCom&utm_source=autolistCom&utm_medium=organic"
                        rel="nofollow"
                      >
                        Principal Engineer
                        <span>Austin, TX</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text">
                {ReactHtmlParser(t('aboutUs.position.apply'))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .message-container {
          padding: 85px 0;
          font-size: 17px;
        }

        .positions {
          margin-top: 20px;
        }

        h1,
        h2 {
          font-size: 24px;
          margin: 0 0 18px 0;
          font-weight: 600;
        }

        a {
          font-size: 17px;
          color: ${colors.ALR1};
          text-decoration: none;
          font-weight: 600;
        }

        a:hover {
          text-decoration: none;
          color: ${colors.ALR1};
          font-weight: bold;
        }

        a span {
          font-size: 16px;
          line-height: 17px;
          display: block;
          color: ${colors.BLACK};
          font-weight: 200;
        }

        ul {
          padding: 0;
          margin: 0;
        }

        li {
          list-style-type: none;
          margin-bottom: 20px;
        }
      `}</style>
    </div>
  );
}

export default CurrentOpenings;
